export default __webpack_public_path__ + "static/media/close.9ff794a5.svg";